








import {
  defineComponent, onMounted, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import ServerAndClient from '@/components/FanCam/ServerAndClient.vue';

const FanCamGreenscreen = defineComponent({
  components: {
    ServerAndClient,
  },
  setup() {
    const { route, router } = useRouter();

    onMounted(() => {
      if (!route.value.params.roomID) router.push({ name: 'FanCamIndex' });
    });

    const freeflowWidth = ref(240);

    // Didn't simplify to calculation just in case they want to change
    function onUpdateConnections(connections: number) {
      if (connections <= 1) freeflowWidth.value = 1280;
      else if (connections <= 4) freeflowWidth.value = 1920 / 2.5; // 2 per row
      else if (connections <= 9) freeflowWidth.value = 1920 / 3.5; // 3 per row
      else if (connections <= 12) freeflowWidth.value = 1920 / 4.5; // 4 per row
      else if (connections <= 25) freeflowWidth.value = 1920 / 5.5; // 5 per row
      else if (connections <= 36) freeflowWidth.value = 1920 / 6.5; // 6 per row
      else if (connections <= 49) freeflowWidth.value = 1920 / 7.5; // 7 per row
      else if (connections <= 64) freeflowWidth.value = 1920 / 8.5; // 8 per row
      else if (connections <= 81) freeflowWidth.value = 1920 / 9.5; // 9 per row
      else if (connections <= 100) freeflowWidth.value = 1920 / 10.5; // 10 per row
      else freeflowWidth.value = 120;
    }

    return {
      route,
      freeflowWidth,
      onUpdateConnections,
    };
  },
});

export default FanCamGreenscreen;
